<template>
    <v-dialog
        v-model="dialog"
        :max-width="maxWidth"
        :style="{ zIndex: zIndex }"
        @keydown.esc="cancel"
        :persistent="persistent"
        :width="width"
    >
        <v-card>
            <v-card-title class="headline"
                ><p>{{ title }}</p></v-card-title
            >

            <v-card-text v-show="!!message">
                <span v-html="message"></span>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    class="col"
                    :color="cancelColor"
                    text
                    @click.native="cancel"
                    >{{ cancelText }}</v-btn
                >
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    :color="confirmColor"
                    text
                    @click.native="agree"
                    >{{ confirmText }}</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        persistent: {
            type: Boolean,
            default: () => {
                return false
            },
        },
        width: {
            default: () => {
                return '300px'
            },
        },
        confirmColor: {
            type: String,
            default: () => {
                return 'red darken-1'
            },
        },
        cancelColor: {
            type: String,
            default: () => {
                return 'grey'
            },
        },
        confirmText: {
            type: String,
            default: function() {
                return this.$t('dialogs-confirm.buttons.yes')
            },
        },
        cancelText: {
            type: String,
            default: function() {
                return this.$t('dialogs-confirm.buttons.cancel')
            },
        },
    },

    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
        zIndex: 200,
        maxWidth: 500,
    }),

    methods: {
        open(title, message) {
            this.dialog = true
            this.title = title
            this.message = message
            return new Promise((resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
            })
        },
        agree() {
            this.resolve(true)
            this.dialog = false
        },
        cancel() {
            this.resolve(false)
            this.dialog = false
        },
    },
}
</script>
